import {
  InputAdornment, InputLabel, Box, SxProps,
} from '@mui/material';
import { useTranslate, InputProps } from 'react-admin';
import SearchIcon from '@mui/icons-material/Search';
import { PointGeometry } from '@x-guard/xgac-types/xgac';
import { GoogleRaCoordinatesInput } from './GoogleRaCoordinatesInput';

type GoogleCoordinatesInputProps = InputProps & {
  label: string;
  isRequired?: boolean;
  placeholder: string;
  country?: string[];
  size?: 'small' | 'medium';
  variant?: 'standard' | 'filled' | 'outlined';
  sx?: SxProps;
  inputProps?: Record<string, unknown>;
  handleSave?: (data: Record<string, PointGeometry>) => void;
  multiline?: boolean;
};

export const GrayGoogleCoordinatesInputWithUpperLabel = ({
  source,
  label,
  placeholder,
  validate,
  size,
  sx,
  inputProps,
  country,
  variant,
  isRequired,
  multiline,
  ...rest
}: GoogleCoordinatesInputProps) => {

  const translate = useTranslate();

  let height;
  if (multiline) {

    height = 'auto';

  } else {

    height = size === 'small' ? 40 : 56;

  }

  return (
    <Box className="bhvk-gray-input" display="flex" flexDirection="column">
      <InputLabel className="input-label" required={isRequired}>
        {translate(typeof label === 'string' ? label : '', { _: label })}
      </InputLabel>
      <GoogleRaCoordinatesInput
        {...rest}
        source={source}
        validate={validate}
        country={country ?? ['nl', 'be', 'de']}
        label={false}
        placeholder={placeholder}
        variant={variant ?? 'outlined'}
        size={size}
        sx={{
          mt: 0,
          mb: 0,
          '& .MuiOutlinedInput-root': {
            boxSizing: 'border-box',
            minHeight: size === 'small' ? 40 : 56,
            height,
            alignItems: 'center',
          },
          width: '100%',
          ...sx,
        }}
        inputProps={{
          ...inputProps,
          endAdornment: <InputAdornment position={'end'}><SearchIcon/></InputAdornment>,
        }}
      />
    </Box>
  );

};
